<template>
  <div class="advantages-of-site ga-12 text-center">
    <div v-if="context.stat.doctors_with_profile_count">
      <div :class="isMobile ? 'text-h6' : 'text-h4'">
        {{ context.stat.doctors_with_profile_count.toLocaleString('ru-RU') }}
      </div>
      <div
        class="text-secondary--text"
        :class="isMobile ? 'text-body-2' : 'text-body-1'"
      >
        {{
          t(
            'врачей зарегистрировались на «{siteName}», управляют профилем и отвечают пациентам',
            { ...options, siteName },
          )
        }}
      </div>
    </div>

    <div>
      <div :class="isMobile ? 'text-h6' : 'text-h4'">
        {{ context.stat.prodoctorov_attendance.toLocaleString('ru-RU') }}
      </div>
      <div
        class="text-secondary--text"
        :class="isMobile ? 'text-body-2' : 'text-body-1'"
      >
        {{
          t(
            'пациентов приходит на «{siteName}» каждый месяц, чтобы найти хорошего доктора',
            { ...options, siteName },
          )
        }}
      </div>
    </div>

    <div>
      <div :class="isMobile ? 'text-h6' : 'text-h4'">
        {{ context.stat.rates_total.toLocaleString('ru-RU') }}
      </div>
      <div
        class="text-secondary--text"
        :class="isMobile ? 'text-body-2' : 'text-body-1'"
      >
        {{
          t(
            'отзывов опубликовано пациентами на «{siteName}»{startYear}',
            {
              ...options,
              siteName,
              startYear: context.request.country.is_russia ? ' с 2011' : ' с 2024',
            },
          )
        }}
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import I18NextVue from 'i18next'
import useContextStore from 'src/store/useContextStore'
import type { ContextStore } from 'src/components/pages/profile/doctors/register/index/types'

const { t, language } = I18NextVue
const options = { ns: language }

const { context }: ContextStore = useContextStore()
const isMobile = computed(() => context.flavour === 'mobile')
const siteName = computed(() => (context.request.country.is_russia ? 'ПроДокторов' : 'YDoc'))
</script>

<style lang="scss" scoped>
.advantages-of-site {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(288px, 1fr));

  & > * {
    display: flex;
    flex-direction: column;
    row-gap: 8px;
  }

  @media (max-width: 885px) {
    text-align: center;

    & > * {
      align-items: center;
    }
  }
}
</style>
